module.exports = "img{\r\n    max-width:100%;\r\n    width:100%;\r\n    display:block;\r\n    top: 0; \r\n    border-bottom: 1px solid rgb(255, 255, 255);\r\n    position:relative;\r\n   }\r\n\r\n   @media (max-width: 768px) {\r\n    .header img {\r\n    position: relative;\r\n    top: 0;\r\n    width: 100%;\r\n    }\r\n   \r\n   }"


//////////////////
// WEBPACK FOOTER
// ./src/app/common/header/header.component.css
// module id = ./src/app/common/header/header.component.css
// module chunks = main